module.exports = __webpack_public_path__ + "static/media/ic_covid_b_2_myway.882100f4.svg";